/* @jsx h */

import { pluginNamespace } from '../config';
import { Fragment } from 'preact';

const Options = ({ options, inputType, filterName }) => {
  return (
    <Fragment>
      <ul className={`search-fieldset__panel-list form__group--${inputType}`}>
        {options.map((option, index) => (
          <li key={option.value}>
            <div className={inputType}>
              <label
                className={`${inputType}__label`}
                htmlFor={`facet-${filterName}-option-${index}`}
              >
                {option.label} ({option.documentCount})
              </label>
              <input
                id={`facet-${filterName}-option-${index}`}
                className={`${inputType}__input`}
                type={inputType}
                name={`${pluginNamespace}[filter][]`}
                value={`${filterName}:${option.value}`}
                data-label={option.label}
                checked={option.selected}
              />
              <span className={`${inputType}__icon`} aria-hidden="true">
                <span class="icon icon--check">
                  <svg
                    class="icon__svg"
                    focusable="false"
                    role="img"
                    aria-hidden="true"
                  >
                    <use href="#icon-check" />
                  </svg>
                </span>
              </span>
            </div>
          </li>
        ))}
      </ul>
    </Fragment>
  );
};

export default Options;
